export default __webpack_public_path__ + "static/media/Lineamientos 12º Concurso Internacional de Bandas Medellín Marcha Musical.9090a074.pdf";